import { IntlShape } from "react-intl";

/**
 * Formats a date using the given `intl` instance.
 * Ensures "MM/DD/YYYY" for US English and locale-based formatting otherwise.
 *
 * @param {Date} date - The date object to format.
 * @param {IntlShape} intl - The `react-intl` instance.
 * @returns {string} - The formatted date.
 */
export const formatDateIntl = (date: Date, intl: IntlShape): string => {
  const locale = intl.locale; // Get the locale from intl instance

  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  };

  // Force "MM/DD/YYYY" for English (US)
  if (locale.startsWith("en")) {
    return new Intl.DateTimeFormat("en-US", options).format(date);
  }

  return new Intl.DateTimeFormat(locale, options).format(date);
};


/**
 * Function to format a Date object to the localized time string.
 * (e.g. German locale returns in this format: HH:MM:SS)
 *
 * @param {Date} date the date object that needs to get converted to a localized date string.
 * @returns {string} the formatted time of the date as a string.
 */
export const formatTime = (date: Date): string => date.toLocaleTimeString();
